import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { cancelButtonStyle, confirmButtonStyle, useStyles } from './styles';
import CLOSE_ICON from '../../assets/svg/close-icon.svg';
import Button from '../Button/Button';
import DELETE_ICON from '../../assets/svg/delete-icon.svg';
import { Dialog } from '@mui/material';
import { LANG_TEXT } from '../../constants/language';

interface ModalCustomProps {
  handleDelete: () => void;
  open: boolean;
  handleClose: () => void;
}

const RemoveItemModal: React.FC<ModalCustomProps> = ({ handleDelete, open, handleClose }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog className={classes.Modal} open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box className={classes.Box}>
        <Box className={classes.BoxHeader}>
          <Box className={classes.BoxTitleModal}>
            <Box className={classes.TitleModal}>
              <Box className={classes.DeleteIcon}>
                <img src={DELETE_ICON} height={24} width={24} alt="DELETE_ICON" />
              </Box>
              <Typography fontSize={18} fontWeight={600} lineHeight={'28px'} color={'var(--Gray-900, #101828)'}>
                {t(LANG_TEXT.REMOVE)}
              </Typography>
            </Box>
            <Box className={classes.Icon} onClick={handleClose}>
              <img src={CLOSE_ICON} height={20} width={20} alt="CLOSE_ICON" />
            </Box>
          </Box>
        </Box>
        <Box className={classes.BoxContent}>
          <Typography fontSize={14} lineHeight={'20px'} color={'var(--Gray-600, #475467)'}>
            {t(LANG_TEXT.REMOVE_TEXT)}
          </Typography>
        </Box>
        <Box className={classes.BoxFooter}>
          <Button
            id="cancel_button"
            fullWidth={false}
            title={t(LANG_TEXT.CANCEL)}
            buttonStyle={cancelButtonStyle}
            sxTextStyle={{ color: 'var(--Gray-700, #344054)', fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}
            onClick={handleClose}
          />
          <Button
            id="confirm_button"
            fullWidth={false}
            title={t(LANG_TEXT.CONFIRM)}
            buttonStyle={confirmButtonStyle}
            sxTextStyle={{ color: 'var(--Base-White, #FFF)', fontSize: '16px', fontWeight: 600, lineHeight: '24px' }}
            onClick={() => {
              handleDelete();
              handleClose();
            }}
          />
        </Box>
      </Box>
    </Dialog>
  );
};

export default RemoveItemModal;
